import $ from 'jquery';

export const HeaderScroll = (() => {
	'use strict';

	let lastKnownScrollY, currentScrollY, ticking, idOfHeader, eleHeader, buffer;

	function init() {
		if (!document.getElementById('site-header')) return;

		lastKnownScrollY = 0;
		currentScrollY = 0;
		ticking = false;
		idOfHeader = 'site-header';
		eleHeader = null;
		buffer = 100;

		window.onload = function () {
			eleHeader = document.getElementById(idOfHeader);
			document.addEventListener('scroll', onScroll, false);
		};
	}

	function onScroll() {
		currentScrollY = window.pageYOffset;
		requestTick();
	}

	function requestTick() {
		if (!ticking) {
			requestAnimationFrame(update);
		}
		ticking = true;
	}

	function update() {
		if (currentScrollY < lastKnownScrollY) {
			showHeader();
		} else if (currentScrollY > lastKnownScrollY && currentScrollY > buffer) {
			hideHeader();
		}
		lastKnownScrollY = currentScrollY;
		ticking = false;
	}

	function showHeader() {
		if (eleHeader.classList.contains('hide')) {
			eleHeader.classList.remove('hide');
		}
	}

	function hideHeader() {
		if (!eleHeader.classList.contains('hide')) {
			eleHeader.classList.add('hide');
		}
	}

	return { init };
})();
